export default "__VITE_ASSET__ae2e3434__"